<template lang="html">
  <layout-grid
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-slot:resource="slotProps">
      <layout-resource
        v-bind="slotProps"
        @click="slotProps.onClick"
        @mousedown="slotProps.onMousedown"
        @touchstart="slotProps.onTouchstart"
        @delete="slotProps.onDelete"
        @rotate="slotProps.onRotate"
      ></layout-resource>
    </template>
  </layout-grid>
</template>

<script>
import {LayoutGrid} from 'dync-booking'
import LayoutResource from './LayoutResource.vue';

export default {
  inheritAttrs: false,
  data() {
    return {};
  },
  components: {
    LayoutGrid,
    LayoutResource
  }
}
</script>

<style lang="scss" scoped>
</style>
